import React from "react";

import LocationIcon from "src/img/noticeboard/white-check-in-location.svg";

import { getCheckInCategory } from "./checkIn";
import {
    BadgeButton,
    CategoryIconWrapper
} from "./CheckInControls.styled";

/** @param {{ category: string, textColor?: string }} props */
export const CheckInBadge = ({ category, textColor }) => {
    const configuredCategory = getCheckInCategory(category);

    return (
        <BadgeButton
            as="span"
            title={configuredCategory.label}
            $color={configuredCategory.color}
            $softColor={configuredCategory.softColor}
            $textColor={textColor}
        >
            <CategoryIconWrapper $color={configuredCategory.color}>
                <img src={configuredCategory.icon} alt="" />
            </CategoryIconWrapper>
            <span>{configuredCategory.label}</span>
        </BadgeButton>
    );
};

/** @param {{ placeName: string, onClick: () => void, textColor?: string }} props */
export const CheckInLocationBadge = ({ placeName, onClick, textColor }) => (
    <BadgeButton
        type="button"
        title={placeName}
        $color="#2F6FDB"
        $softColor=""
        $textColor={textColor}
        onClick={onClick}
    >
        <CategoryIconWrapper $color="#2F6FDB">
            <img src={LocationIcon} alt="" />
        </CategoryIconWrapper>
        <span>{placeName}</span>
    </BadgeButton>
);
